import type {
    LoginCommerceCustomerRequest,
    LoginCommerceCustomerResponse,
} from "@teqtank/commerce-contracts";
import { defineCommerceOperation } from "@teqtank/commerce-transport";
export const loginCommerceCustomerOperation = defineCommerceOperation<
    LoginCommerceCustomerRequest,
    LoginCommerceCustomerResponse
>("commerce.customer.login");
